export const pageLinks = [

    {
        name: "Shop",
        isExternal: false, //is an external URL
        page: '/coming-soon'
    },

    {
        name: "Donate",
        isExternal: false, //is an external URL
        page: '/coming-soon'
    },

    {
        name: "Login",
        isExternal: true, //is an external URL
        page: 'login',
        url: null
    },

];

export const madeByOlaUrl = "https://laolu.netlify.app/"